export default "__VITE_ASSET__vf$Uj5kI__"